import {
  CustomerMyServiceCases,
  CustomerMyServiceCasesDto,
  CustomerServiceCaseDetail,
  CustomerServiceCaseDetailDto,
  CustomerServiceCaseRow,
  CustomerServiceCaseRowDto,
  ServiceCaseLog,
  ServiceCaseLogDto,
} from '../models/customer-service/service-case.model';

/*#################################################### Function ################################################*/

/**
 * Mapper สำหรับแปลง CustomerServiceCaseRowDto เป็น CustomerServiceCaseRow
 */
export function mapCustomerServiceCaseRowDtoToModel(
  dto: CustomerServiceCaseRowDto,
): CustomerServiceCaseRow {
  return {
    id: dto?.id ?? 0,
    caseNo: dto?.caseNo ?? '',
    issueTypeId: dto?.issueTypeId ?? null,
    issueTypeName: dto?.issueTypeName ?? '',
    issueTypeCode: dto?.issueTypeCode ?? '',
    status: dto?.status ?? '',
    statusLabel: dto?.statusLabel ?? '',
    subject: dto?.subject ?? '',
    siteName: dto?.siteName ?? '',
    createDate: dto?.createDate ? new Date(dto.createDate) : null,
    resolvedAt: dto?.resolvedAt ? new Date(dto.resolvedAt) : null,
    closedAt: dto?.closedAt ? new Date(dto.closedAt) : null,
    canConfirm: dto?.canConfirm ?? false,
  };
}

/**
 * Mapper สำหรับแปลง CustomerMyServiceCasesDto เป็น CustomerMyServiceCases
 */
export function mapCustomerMyServiceCasesDtoToModel(
  dto: CustomerMyServiceCasesDto,
): CustomerMyServiceCases {
  return {
    active: (dto?.active ?? []).map(mapCustomerServiceCaseRowDtoToModel),
    history: (dto?.history ?? []).map(mapCustomerServiceCaseRowDtoToModel),
  };
}

/**
 * Mapper สำหรับแปลง ServiceCaseLogDto เป็น ServiceCaseLog
 */
export function mapServiceCaseLogDtoToModel(
  dto: ServiceCaseLogDto,
): ServiceCaseLog {
  return {
    id: dto?.id ?? 0,
    actionType: dto?.actionType ?? '',
    oldStatus: dto?.oldStatus ?? '',
    newStatus: dto?.newStatus ?? '',
    message: dto?.message ?? '',
    isCustomerVisible: dto?.isCustomerVisible ?? false,
    attachmentUrl: dto?.attachmentUrl ?? '',
    actorUid: dto?.actorUid ?? null,
    actorUserName: dto?.actorUserName ?? '',
    createDate: dto?.createDate ? new Date(dto.createDate) : null,
  };
}

/**
 * Mapper สำหรับแปลง CustomerServiceCaseDetailDto เป็น CustomerServiceCaseDetail
 */
export function mapCustomerServiceCaseDetailDtoToModel(
  dto: CustomerServiceCaseDetailDto,
): CustomerServiceCaseDetail {
  const baseRow = mapCustomerServiceCaseRowDtoToModel(dto);
  return {
    ...baseRow,
    description: dto?.description ?? '',
    resolutionSummary: dto?.resolutionSummary ?? '',
    customerStatusNote: dto?.customerStatusNote ?? '',
    cancelReason: dto?.cancelReason ?? '',
    timeline: (dto?.timeline ?? []).map(mapServiceCaseLogDtoToModel),
  };
}
